import apiClient from '../index';

export const getAuditExceptions = async (auditId: string) => {
	const response = await apiClient.get(`/audits/${auditId}/exceptions`);
	return response.data;
};

export const getException = async (exceptionId: string) => {
	const response = await apiClient.get(`/exceptions/${exceptionId}`);
	return response.data;
};

export const getExceptionEvents = async (exceptionId: string) => {
	const response = await apiClient.get(`/exceptions/${exceptionId}/events`);
	return response.data;
};

export const updateException = async (
	exceptionId: string,
	status: string,
	note: string,
) => {
	const response = await apiClient.patch(`/exceptions/${exceptionId}`, {
		status,
		note,
	});
	return response.data;
};
